import { motion, useReducedMotion } from "framer-motion";

// Static configs hoisted so they are not recreated on every render.
const VIEWPORT = { once: true, margin: "-60px" };

export const Reveal = ({ children, className, delay = 0 }) => {
  const reduce = useReducedMotion();

  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={false}
      whileInView={{ opacity: [1, 1], y: [0, 0] }}
      viewport={VIEWPORT}
      transition={{ duration: 0.18, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
